import React from "react";
import logo from "../../common/media/cc-logo-black.svg";
import { footerLinks } from "../../common/util/uiConfigs/footerConfiguration";

const Footer = () => {
    return (
        <footer className="w-100 footer-img">
            <div className="container py-4 mobile-py-0">
                <hr className="mb-4" style={{ borderTop: '3px solid lightgray' }} />
                <p className="footer-title mb-1"><b>POWERED BY</b></p>
                <div className="d-flex mb-4">
                    <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                        <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                    </a>
                </div>

                <hr className="mb-4" style={{ borderTop: '1px solid lightgray' }} />

                <div className="row">
                    <div className="col-4">
                        <a className="mb-1 color-primary g-center list-item" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a>
                        <a className="mb-1 color-primary g-center list-item" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a>
                    </div>
                    <div className="col-4">
                        <a className="mb-1 color-primary g-center list-item" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
                        <a className="mb-1 color-primary g-center list-item" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a>
                    </div>
                    <div className="col-4">
                        <a className="mb-1 color-primary g-center list-item" href={footerLinks?.contactUs} target="_blank" rel="noopener noreferrer">Contact us</a>
                        <a className="mb-1 color-primary g-center list-item no-translate" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;